"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBAccordion = require("./HBAccordion.styles");
var _useAccordionAnimation = require("../common/useAccordionAnimation");
var HBAccordionDetails = function HBAccordionDetails(_ref) {
  var children = _ref.children;
  var animation = (0, _useAccordionAnimation.useAccordionAnimation)();
  return /*#__PURE__*/_react["default"].createElement(_HBAccordion.DetailsContainer, animation, children);
};
var _default = exports["default"] = HBAccordionDetails;
//# sourceMappingURL=HBAccordionDetails.js.map